import { defineMessages } from 'react-intl-next';

export const i18n: {
	confluenceIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	assetsIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	talentIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	confluenceIconLabel: {
		id: 'rovo-search.confluence.filter.icon.label',
		defaultMessage: 'Confluence filter',
		description:
			'An icon that is displayed when there are no products selected to signify that the filter is associated with Confluence',
	},
	jiraIconLabel: {
		id: 'rovo-search.jira.filter.icon.label',
		defaultMessage: 'Jira filter',
		description:
			'An icon that is displayed when there are no products selected to signify that the filter is associated with Jira',
	},
	assetsIconLabel: {
		id: 'rovo-search.assets.filter.icon.label',
		defaultMessage: 'Assets filter',
		description:
			'An icon that is displayed when there are no products selected to signify that the filter is associated with Assets',
	},
	talentIconLabel: {
		id: 'rovo-search.talent.filter.icon.label',
		defaultMessage: 'Talent filter',
		description:
			'An icon that is displayed when there are no products selected to signify that the filter is associated with Talent',
	},
});
